// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wPP9Q","button__name":"Button_button__name__+cRh-"};